import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../../common/actions';
import { getKey, isAddNPay, clientMessage } from '../../../utils/common';
import CONSTANT from '../../../utils/constants';

class Renewal extends Component {
  mapClientMessage() {
    let msg = this.props.subscription.renewMessage;
    const clientSubsMsg = clientMessage(CONSTANT.SUBSCRIPTION.toLowerCase(), this.props.cache);
    getKey(clientSubsMsg, 'label.renewMessage') &&
      (msg = getKey(clientSubsMsg, 'label.renewMessage'));
    return msg;
  }

  showRenewMessage(subscription) {
    const paymentOptions = this.props.cache.getData('paymentOptions');
    return (
      getKey(subscription, 'isEnabled') &&
      getKey(subscription, 'renewMessage') &&
      isAddNPay(paymentOptions, this.props.cache)
    );
  }

  render({ subscription }, {}) {
    if (this.showRenewMessage(subscription)) {
      return (
        <div class="ptm-msg-info"> {this.mapClientMessage() || subscription.renewMessage}</div>
      );
    }
    return '';
  }
}
export default connect(
  'subscription, cache',
  onChange
)(Renewal);



// WEBPACK FOOTER //
// ./components/subscription/renewal/index.js